<div class="charts-main-container">
  <div class="header">
    <div class="header-content">
      <div class="header-left">
        <div class="header-text">
          <h2>{{ 'CHARTS.TITLE' | translate }}</h2>
          <p class="subtitle">{{ 'CHARTS.HOME' | translate }}</p>
        </div>
      </div>

      <div class="header-filter">
        <app-notification-filter [notifications]="charts" storageKey="charts_filter_unread">
        </app-notification-filter>
      </div>
    </div>
  </div>

  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
      <button class="retry-button" (click)="loadCharts()">{{ 'GLOBAL.RETRY' | translate }}</button>
    </div>
  </div>

  <div class="content" *ngIf="!loading() && !error; else loadingTemplate">
    <div class="items-grid">
      <div class="item-card" *ngFor="let chart of filteredCharts" [class.unread]="!chart.isRead"
        (click)="onChartClick(chart.notificationID)" role="button" tabindex="0"
        (keydown.enter)="onChartClick(chart.notificationID)" (keydown.space)="onChartClick(chart.notificationID)">

        <div class="card-header">
          <h3 class="item-title">{{ chart.title }}</h3>
          <span class="item-date">{{ formatDate(chart.created) }}</span>
        </div>

        <div class="card-body">
          <p class="item-preview">{{ getPreviewText(chart.body) }}</p>
        </div>

        <div class="card-footer">
          <span class="read-status" [class.unread]="!chart.isRead">
            {{ getReadStatusText(chart.isRead) | translate }}
          </span>
          <span class="view-details">{{ 'GLOBAL.DETAIL' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="no-items" *ngIf="filteredCharts.length === 0">
      <div class="no-items-card">
        <div class="no-items-icon">
          <mat-icon>insert_chart_outlined</mat-icon>
        </div>
        <h3>{{ 'CHARTS.NOGRAPHS' | translate }}</h3>
        <p>{{ 'CHARTS.NOGRAPHSTOSHOW' | translate }}</p>
      </div>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'CHARTS.LOADING' | translate }}</p>
    </div>
  </ng-template>
</div>